import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { currentCalendarPrice, currentSummaryPrice } from './recordPriceReactiveVars';
import { isPriceRecordValidForComparison } from './isPriceRecordValidForComparison';
const RECORD_PRICE_SUMMARY_CALENDAR_MUTATION = gql `
    mutation RecordPriceSummaryToCalendar($tripStateId: ID!, $summaryPrice: Int!, $calendarPrice: Int!) {
        recordPriceSummaryToCalendar(
            tripStateId: $tripStateId
            summaryPrice: $summaryPrice
            calendarPrice: $calendarPrice
        ) {
            calendarPrice
            hasPriceDifference
            summaryPrice
            hasChildren
            priceTolerance
            isPriceIncrease
            hasMultiRoom
        }
    }
`;
export function useRecordPriceSummaryToCalendar(tracking) {
    const [recordPriceSummaryToCalendar] = useMutation(RECORD_PRICE_SUMMARY_CALENDAR_MUTATION);
    const { price: calendarPrice } = currentCalendarPrice();
    const { price: summaryPrice } = currentSummaryPrice();
    return useEffect(() => {
        const calendarPriceRecord = currentCalendarPrice();
        const summaryPriceRecord = currentSummaryPrice();
        if (isPriceRecordValidForComparison(calendarPriceRecord, summaryPriceRecord) === false) {
            return;
        }
        const roundedCalendarPriceRecord = Math.round(Number(calendarPriceRecord.price));
        const roundedSummaryPriceRecord = Math.round(Number(summaryPriceRecord.price));
        if (roundedCalendarPriceRecord !== roundedSummaryPriceRecord) {
            tracking('HC Price Difference Estab');
        }
        recordPriceSummaryToCalendar({
            variables: {
                tripStateId: calendarPriceRecord.tripStateId,
                summaryPrice: roundedSummaryPriceRecord,
                calendarPrice: roundedCalendarPriceRecord,
            },
        });
    }, [summaryPrice, calendarPrice, recordPriceSummaryToCalendar, tracking]);
}
